module.exports = __webpack_public_path__ + "img/1.9.TU.c2c80b9c.png";